<div
    class="sp-video-root video-widget-width"
    [id]="form?.displayId()"
    [class.video-zero-variant]="isZero()"
    [class.is-empty]="isEmpty()"
    [style.--video-preview-size]="previewSize()"
    [style.--video-aspect-ratio]="aspectRatio()"
    [style.--video-width]="videoWidth()"
    [style.--video-display]="videoDisplay()"
    [style.--video-margin]="videoMargin()"
    [style.--video-max-width]="videoMaxWidth()"
    [style]="playButtonCssVars()"
>
    <div
        class="video"
        #resizeBox
        mwlResizable
        (resizeStart)="onResizeStart($event, resizeBox)"
        (resizing)="onResizing($event, resizeBox)"
        (resizeEnd)="onResizeEnd($event, resizeBox)"
    >
        @if (form.videoUrl().value() || form.videoFile().value()) {
            <div
                spPlayer
                spPlayerLazy
                [playerSources]="videoSource()"
                [playerPoster]="form.customPreviewUrl().value()"
                [isShorts]="form.isShorts().value()"
                style="width: 100%"
            ></div>
        }

        @if (!form.videoUrl().value() && !form.videoFile().value()) {
            <div class="sp-video-blank">
                <img class="video" [src]="blankVideoImg()" alt="gallery_blank" />
            </div>
        }

        @if (form.videoUrl().value() || form.videoFile().value()) {
            <div class="dragHandle corner" mwlResizeHandle [resizeEdges]="{ bottom: true, right: true }">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path
                            d="M16 15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16L12 16C11.8024 15.9999 11.6093 15.9412 11.445 15.8314C11.2807 15.7215 11.1527 15.5655 11.077 15.383C11.0269 15.2615 11.0007 15.1314 11 15C11.0003 14.7352 11.1057 14.4813 11.293 14.294L12.086 13.501L9.293 10.707C9.19749 10.6148 9.12132 10.5044 9.06891 10.3824C9.0165 10.2604 8.98892 10.1292 8.98776 9.9964C8.98661 9.86362 9.01188 9.73194 9.06216 9.60904C9.11244 9.48614 9.18672 9.3745 9.28061 9.28061C9.3745 9.18672 9.48614 9.11246 9.60904 9.06218C9.73194 9.0119 9.86362 8.98659 9.9964 8.98775C10.1292 8.9889 10.2604 9.01648 10.3824 9.06889C10.5044 9.1213 10.6148 9.19749 10.707 9.293L13.5 12.086L14.293 11.293C14.4329 11.1532 14.611 11.058 14.805 11.0194C14.9989 10.9808 15.2 11.0007 15.3827 11.0763C15.5654 11.152 15.7215 11.2801 15.8314 11.4445C15.9413 11.6089 16 11.8022 16 12L16 15ZM6.707 6.707C6.51947 6.89447 6.26516 6.99979 6 6.99979C5.73484 6.99979 5.48053 6.89447 5.293 6.707L2.5 3.914L1.707 4.707C1.56715 4.84681 1.38899 4.94202 1.19504 4.98059C1.00108 5.01916 0.800039 4.99935 0.61734 4.92368C0.43464 4.84801 0.278493 4.71988 0.168609 4.55547C0.0587248 4.39106 4.17084e-05 4.19775 -5.24537e-07 4L-6.55671e-07 1C-6.67264e-07 0.734783 0.105371 0.480429 0.292907 0.292892C0.480443 0.105356 0.734783 -3.21184e-08 0.999999 -4.37114e-08L4 -1.74846e-07C4.19754 0.000239189 4.39058 0.0589874 4.55478 0.168823C4.71897 0.278659 4.84698 0.434663 4.92261 0.617157C4.99824 0.799651 5.01811 1.00046 4.97974 1.19424C4.94137 1.38803 4.84647 1.56609 4.707 1.70599L3.914 2.49899L6.707 5.293C6.89447 5.48053 6.99979 5.73484 6.99979 6C6.99979 6.26516 6.89447 6.51947 6.707 6.707Z"
                            fill="white"
                        />
                    </g>
                </svg>
            </div>
        }
    </div>
</div>
